import Input from './Input.view';

export default Input;
